import { useCallback, useRef, useState } from 'react';
import ReaderAffiliatePromoModal from '../components/ads/ReaderAffiliatePromoModal';
import { shouldShowAds } from '../utils/adsEligibility';
import { pickAffiliateProducts } from '../utils/pickAffiliateProducts';

const DEFAULT_FLIPS_PER_PROMO = 4;

/**
 * Call `recordForwardFlip()` when the reader advances a page/spread.
 * Shows a soft affiliate modal every N forward flips for non-premium users.
 */
export default function useReaderAffiliatePromo(
  placement = 'reader',
  { flipsPerPromo = DEFAULT_FLIPS_PER_PROMO } = {},
) {
  const flipCountRef = useRef(0);
  const openRef = useRef(false);
  const interval = Math.max(1, flipsPerPromo);
  const [product, setProduct] = useState(null);

  const recordForwardFlip = useCallback(() => {
    if (!shouldShowAds()) return;
    if (openRef.current) return;

    flipCountRef.current += 1;
    if (flipCountRef.current % interval !== 0) return;

    const [picked] = pickAffiliateProducts(1, flipCountRef.current + placement.length);
    if (!picked) return;

    openRef.current = true;
    setProduct(picked);
  }, [interval, placement]);

  const closePromo = useCallback(() => {
    openRef.current = false;
    setProduct(null);
  }, []);

  const promoElement = product ? (
    <ReaderAffiliatePromoModal
      product={product}
      placement={placement}
      onClose={closePromo}
    />
  ) : null;

  return { recordForwardFlip, promoElement };
}
